import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { doc, Firestore, getDoc, setDoc } from '@angular/fire/firestore';
import { UserService } from '../components/login/user.service';
import { Conversation } from '../components/login/user.interface';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class ChatService {
  // private apiUrl = 'http://localhost:3000/chat/query';
  // private apiUrl = 'https://beeasy-back.onrender.com/chat/query';
  apiUrl = '';

  auth = inject(Auth);
  userService = inject(UserService);
  firestore = inject(Firestore);
  apiService = inject(ApiService);
  
  constructor(private http: HttpClient) {
    this.apiUrl = this.apiService.getApi() + '/chat/query'
  }

  queryChat(
    query: string,
    history: { role: string; content: string }[],
    workSpaceClientId: string,
    options?: {
      defaultTone?: string;
      rolePrompt?: string;
      defaultInstructions?: string[];
      integration?: string;
    }
  ) {
    return this.http.post<{ answer: string }>(this.apiUrl, {
      query,
      history,
      workSpaceClientId,
      ...options
    });
  }

  async updateConversationById(conversationId: string) {
    const user = this.auth.currentUser;

    if(!user) {
      return;
    }
    // this.noClient.set(false);

    const userId = user.uid;

    const workSpaceId = await this.userService.getWorkspaceIdForUser(userId);

    const convoDocRef = doc(this.firestore, `workspaces/${workSpaceId}/conversations/${conversationId}`);
    const docSnap = await getDoc(convoDocRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      
      const updatedConversation: Conversation = {
        conversationId,
        humanRequest: true
      };
      console.log('updatedConversation', updatedConversation)
      await setDoc(convoDocRef, updatedConversation, { merge: true });
    } else {
      console.warn('No se encontró la conversación con ese ID.');
    }
  }
}